export const addresses = {
  svgHelperAddress: "0x9F2dC3f778c07987Fcf5a225c3EFD29400930D50",
  splatterAddress: "0xFf2738683Eb630cf6322aBf47c449bDc963EA062",
  splatterArtAddress: "0xB6260e3b97668DCa728d50f4F25C9f824D7BF406",
  splatterToken: "0x6ef6ca41e5EAe230bf481fFe99Fa231CD8E1d3d8",
};
